<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="noindent"><span class="gray">For Holly Dauphin Fields-<br/>and the sweet memories of friends and family<br/>who left us too soon.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003dedication.vue?5d8d2193